import React, { PureComponent } from 'react';
import { GigCardShell, Media, Title, SellerInfo, SellerLevel, Username, SellerCountry, SellerResponseTime, Price, Badge, Rating, CollectGig, ListViewInfo } from '../../shared';
import { getCurrency, adaptGigData, getGigAssets, getRisingTalentExpVariation } from '../../utils';
import { Avatar } from '@fiverr/fit';
import translations from '../../translations.en.json';
import '@fiverr/globals';
import '../style.scss';

class ListViewDesktop extends PureComponent {

    constructor(props) {
        super(props);

        i18n.add(translations);
    }

    getBadges(gig, showRisingTalentBadge) {
        const {
            is_featured,
            quality_choice,
            is_available_now,
            seller_name,
            is_pro,
            gig_id
        } = gig;
        const badges = [];

        if (showRisingTalentBadge) {
            badges.push(<Badge key={`${gig_id}_badge_talent`} type="talent"/>);
        } else if (is_featured) {
            badges.push(<Badge key={`${gig_id}_badge_featured`} type="featured"/>);
        } else if (quality_choice) {
            badges.push(<Badge key={`${gig_id}_badge_choice`} type="choice"/>);
        } else if (is_available_now) {
            badges.push(<Badge key={`${gig_id}_badge_now`} type="now" seller={seller_name}/>);
        }

        is_pro && badges.push(<Badge key={`${gig_id}_badge_pro`} type="pro"/>);

        return badges;
    }

    render() {
        const { gig, user, context = {}, updateCollections } = this.props,
            userId = user && user.userId || null,
            risingTalentExpVariation = getRisingTalentExpVariation(gig.type, context.abTests),
            limitDisplayedRatings = context.abTests && context.abTests.RATINGS_THRESHOLD_ONE_HUNDRED === 2,
            shouldRenderRating = (gig.rating > 0 || gig.is_pro || risingTalentExpVariation) && risingTalentExpVariation !== 2;

        adaptGigData(gig, {context});

        return (
            <GigCardShell key={gig.gig_id} type="list-view-card" gigId={gig.gig_id}>
                <div className="col-media">
                    <a href={gig.gig_url} className="js-gig-card-imp-data">
                        <Media assets={getGigAssets(gig)} gigId={gig.gig_id} userId={userId}/>
                    </a>
                </div>
                <div className="col-gig-info">
                    <Title gigUrl={gig.gig_url} caption={gig.iwill_title}/>
                    <SellerInfo>
                        {gig.is_seller_online && <span className="is-online"></span>}
                        <Avatar src={gig.seller_img}/>
                        <Username name={gig.seller_name} url={gig.seller_url} prefix={i18n.t('general.by')} context={context}/>
                        {!risingTalentExpVariation && <SellerLevel level={gig.seller_level} isPro={gig.is_pro}/>}
                        {gig.seller_country_name && <SellerCountry country={gig.seller_country_name} comma={true}/>}
                        {gig.seller_avg_response && <SellerResponseTime responseTime={gig.seller_avg_response} comma={true}/>}
                    </SellerInfo>
                    <Price gigUrl={gig.gig_url}
                        price={getCurrency(gig.price_i, true)}
                        showStartingAt={gig.show_starting_at}
                        averagePrice={gig.average_price && getCurrency(gig.average_price, true)}
                        medianPrice={gig.median_price && getCurrency(gig.median_price, true)}/>
                    {shouldRenderRating && <Rating score={gig.rating} votes={gig.rating_count} starSize={16} starCount={gig.rating > 0 ? 5 : 1} isPro={gig.is_pro} risingTalentExpVariation={risingTalentExpVariation === 3} limitDisplayedRatings={limitDisplayedRatings}/>}
                    {this.getBadges(gig, risingTalentExpVariation === 2)}
                    <ListViewInfo platforms={gig.metadata && gig.metadata.platform ? gig.metadata.platform : null}
                        skills={gig.skills}
                        avgDeliveryTime={gig.avg_delivery_time}/>
                    <CollectGig gigId={gig.gig_id} sellerId={gig.seller_id} updateCollections={updateCollections} user={user} showCollMenu={true} icon="fa fa-ellipsis-v"/>
                </div>
            </GigCardShell>
        );
    }
}

export default ListViewDesktop;



// WEBPACK FOOTER //
// ./src/list_view_card/views/desktop.js